

export async function loadTemplate(name) {
	// Check if template already loaded
	if (templateStore.has(name)) return;

	const templatePath = wpcore.siteUrl + '/app/themes/wpcore/assets/template/' + name + '?v=' + Date.now();

	try {
		const response = await fetch(templatePath);
		const templateContent = await response.text();
		templateStore.set(name, templateContent);
	} catch (error) {
		console.error('Error loading template:', error);
	}
}

class TemplateStore {
	constructor() {
		this.templates = {};
	}

	set(name, content) {
		this.templates[name] = content;
	}

	get(name) {
		return this.templates[name] || null;
	}

	has(name) {
		return !!this.templates[name];
	}

	clear(name) {
		if (name) {
			delete this.templates[name];
		} else {
			this.templates = {};
		}
	}
}

// Export singleton instance
const templateStore = new TemplateStore();
export { templateStore };
